import Subnet from './subnet.vue'
export default Subnet



// WEBPACK FOOTER //
// ./src/components/subnet/index.js